// ─────────────────────────────────────────────────────────────────
// Klarar enheten att köra modellen? Kräver WebGPU (Chrome/Edge, Chrome på
// Android, Safari från iOS/macOS 26) — WASM-reserven är för tung för mobiler
// med den här modellen, så utan WebGPU döljs knappen helt.
// ─────────────────────────────────────────────────────────────────

interface GpuAdapterLike { features: { has(name: string): boolean } }
interface NavigatorLike {
  gpu?: { requestAdapter(): Promise<GpuAdapterLike | null> };
  deviceMemory?: number;
}

/** Minsta RAM (GB) där det är rimligt att ladda en ~115 MB-modell. Bara Chromium rapporterar det. */
const MIN_DEVICE_MEMORY_GB = 4;
/** Längsta väntan på WebGPU-adaptern. */
const ADAPTER_TIMEOUT_MS = 3000;

export async function isDeviceSupported(dtype: 'fp16' | 'fp32', nav: NavigatorLike = navigator as unknown as NavigatorLike): Promise<boolean> {
  if (typeof Worker === 'undefined' || !nav.gpu) return false;
  if (nav.deviceMemory !== undefined && nav.deviceMemory < MIN_DEVICE_MEMORY_GB) return false;
  try {
    // requestAdapter() kan hänga i vissa webbvyer — då räknas enheten som utan stöd.
    const adapter = await Promise.race([
      nav.gpu.requestAdapter(),
      new Promise<null>(resolve => setTimeout(() => resolve(null), ADAPTER_TIMEOUT_MS)),
    ]);
    if (!adapter) return false;
    return dtype !== 'fp16' || adapter.features.has('shader-f16');
  } catch {
    return false;
  }
}
